<template>
	<div class="ak-default">
		<header>
			<myNav></myNav>
		</header>
		<!--<div style="height: 60px;"></div>-->
		<section>
			<article>
				<myNaver></myNaver>
				<div style="padding:20px 30px;box-sizing:border-box;flex:1;min-width:0;height:100%;overflow-y: auto;">
					<router-view></router-view>
					<div style="height:10px;"></div>
				</div>
			</article>
		</section>
		
	</div>
</template>

<script>
import myNaver from "../components/Index/naver.vue";
import myNav from "../components/Index/nav.vue";
export default {
    components:{
        myNaver,
        myNav
    },
    data () {
        return {
            bodyHeight:0
        };
    },
    mounted() {
        // if(!localStorage.getItem("producttoken")){
        // 	this.$router.push("/login");
        // }
    },
    created () {
        this.bodyHeight=document.body.clientHeight;
        window.onresize = () => {
            this.bodyHeight=document.body.clientHeight;
        };
    },
    computed:{
        minHeight () {
            return this.bodyHeight-100;
        }
    }
};
</script>

<style lang="less" scoped>
	div.ak-default{
		height: 100%;
		margin: 0 auto;
		box-sizing: border-box;
		header{
			height: 74px;
			width: 100%;
			overflow: hidden;
			z-index: 99;
		}
		section{
			min-width: 1180px;
			margin: 0 auto;
			height:calc(~"100% - 74px");
			article{
				height: 100%;
				display: flex;
			}
		}
	}
</style>